import GenericDB from './generic-db';

export default class BillingItemsDB extends GenericDB {
  constructor() {
    super('billingItems');
  }

  /**
   * DERIVED AND SERVER-WRITTEN. The projector computes every document from a session activity and
   * the configuration around it, and reconciles what it computed against what is stored. The rules
   * give a browser no write path at all, so there is nothing to write here and never will be: a
   * wrong item is fixed by fixing the configuration it came from, which is the only correction that
   * survives the next projection run.
   *
   * CLINIC-SCOPED, and the scope is `clinicId` rather than the bare `clinic` its neighbours use.
   * The field names here mirror the claim vocabulary the item is built in, so every read must
   * constrain on `clinicId` — the rules require it too, and an unscoped read reaches nothing rather
   * than reaching too far.
   */
}
